<template>
  <footer class="footer -type-1">
    <div class="container">
      <div class="pt-6 0 pb-20">
        <div class="row y-gap-40 justify-between">
          <!-- Column 1: Logo & About -->
          <div class="col-xl-4 col-lg-4 col-md-6">
            <div class="footer-logo">
              <router-link to="/">
                <img src="@/assets/img/logo_color_letters.svg" alt="Ada Bojana For Me" width="200" />
              </router-link>
            </div>
            <p class="footer-tagline mt-20">Tvoja avantura. Naša zajednica.</p>
            <p class="footer-about mt-10">
              Ukoliko ste ljubitelj netaknute prirode, volite kite surf i skijanje na
              vodi, želite da osetite autentičnost prirode na reci Bojani i tražite
              iskonsku avanturu i drugačiji odmor, odaberite sojenice na reci, kućice,
              apartmane ili kampove.
            </p>
            <div class="footer-social mt-30">
              <span class="footer-social__label">Zapratite nas</span>
              <div class="footer-social__icons">
                <a
                  href="https://sr-rs.facebook.com/adabojanaforme"
                  target="_blank"
                  rel="noopener"
                  class="social-icon"
                >
                  <i class="ti-facebook"></i>
                </a>
                <a
                  href="https://www.instagram.com/adabojanaforme"
                  target="_blank"
                  rel="noopener"
                  class="social-icon"
                >
                  <i class="ti-instagram"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@adabojanaforme"
                  target="_blank"
                  rel="noopener"
                  class="social-icon"
                  title="TikTok"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.1a8.16 8.16 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.47z"
                    />
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/company/adabojanaforme"
                  target="_blank"
                  rel="noopener"
                  class="social-icon"
                >
                  <i class="ti-linkedin"></i>
                </a>
              </div>
            </div>
          </div>

          <!-- Column 2: Sitemap -->
          <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6">
            <h5 class="footer-title">Sitemap</h5>
            <ul class="footer-links">
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/smestaj-ulcinj-ada-bojana">Smeštaj</router-link></li>
              <li><router-link to="/city/bojana">Ada Bojana</router-link></li>
              <li><router-link to="/blog">Blog</router-link></li>
              <li><router-link to="/contact">Kontakt</router-link></li>
            </ul>
          </div>

          <!-- Column 3: Support -->
          <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6">
            <h5 class="footer-title">Podrška</h5>
            <ul class="footer-links">
              <li><router-link to="/contact">Kontakt</router-link></li>
              <li><router-link to="/about">O nama</router-link></li>
              <li><router-link :to="{ path: '/legal', hash: '#cookies' }">Pravna obaveštenja</router-link></li>
              <li><router-link :to="{ path: '/legal', hash: '#privacy' }">Politika privatnosti</router-link></li>
              <li><router-link :to="{ path: '/legal', hash: '#terms' }">Uslovi korišćenja</router-link></li>
            </ul>
          </div>

          <!-- Column 4: Contact -->
          <div class="col-xl-3 col-lg-3 col-md-6">
            <h5 class="footer-title">Kontakt</h5>
            <ul class="footer-contacts">
              <li>
                <i class="ti-email"></i>
                <a href="mailto:info@adabojanaforme.com">info@adabojanaforme.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Bottom Bar -->
      <div class="footer-bottom">
        <div class="row y-gap-10 justify-between items-center">
          <div class="col-auto">
            <div class="footer-copyright">
              © {{ currentYear }} Ada Bojana For Me. Sva prava zadržana.
            </div>
          </div>
          <div class="col-auto">
            <div class="footer-bottom-links">
              <router-link :to="{ path: '/legal', hash: '#terms' }">Uslovi korišćenja</router-link>
              <router-link :to="{ path: '/legal', hash: '#privacy' }">Politika privatnosti</router-link>
              <button type="button" class="footer-bottom-link-btn" @click="openCookieSettings">
                Podešavanja kolačića
              </button>
            </div>
          </div>
          <div class="col-auto">
            <div class="footer-language">
              <select v-model="selectedLanguage" @change="switchLanguage($event)">
                <option v-for="(item, i) in languages" :key="i" :value="item.lang">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import i18nService from "@/services/i18n.service.js";
import { openCookiePreferences } from "@/utils/cookieConsent";

export default {
  name: "Footer",

  data() {
    return {
      languages: i18nService.languages,
      selectedLanguage: i18nService.getActiveLanguage(),
    };
  },

  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },

  methods: {
    switchLanguage(event) {
      i18nService.setActiveLanguage(event.target.value);
      window.location.reload();
    },
    openCookieSettings() {
      openCookiePreferences();
    },
  },
};
</script>

<style lang="scss" scoped>
$blue-1: #3554d1;
$dark-1: #051036;
$light-1: #697488;

.footer {
  background-color: #fff;

  &.-type-1 {
    padding-top: 32px;
  }
}

.pt-60 {
  padding-top: 60px;
}
.pb-60 {
  padding-bottom: 60px;
}
.mt-20 {
  margin-top: 20px;
}
.mt-10 {
  margin-top: 10px;
}
.mt-30 {
  margin-top: 30px;
}

// ========== LOGO & ABOUT ==========
.footer-logo {
  img {
    // Logo ostaje originalne boje (bez filtera)
  }
}

.footer-tagline {
  font-size: 20px;
  font-weight: 600;
  color: $dark-1;
  line-height: 1.4;
}

.footer-about {
  font-size: 14px;
  line-height: 1.7;
  color: $light-1;
}

// ========== SOCIAL ==========
.footer-social {
  display: flex;
  align-items: center;
  gap: 15px;

  &__label {
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: $dark-1;
  }

  &__icons {
    display: flex;
    gap: 10px;
  }
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #e5e5e5;
  color: $dark-1;
  font-size: 14px;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    background: $dark-1;
    border-color: $dark-1;
    color: #fff;
  }
}

// ========== TITLE ==========
.footer-title {
  font-size: 16px;
  font-weight: 600;
  color: $dark-1;
  margin-bottom: 20px;
}

// ========== LINKS ==========
.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    font-size: 15px;
    color: $dark-1;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: $blue-1;
    }
  }
}

// ========== CONTACTS ==========
.footer-contacts {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    i {
      font-size: 16px;
      color: $blue-1;
      width: 20px;
    }

    a {
      font-size: 15px;
      color: $dark-1;
      text-decoration: none;
      transition: color 0.3s ease;

      &:hover {
        color: $blue-1;
      }
    }
  }
}

// ========== BOTTOM BAR ==========
.footer-bottom {
  padding: 25px 0;
  border-top: 1px solid #e5e5e5;
}

.footer-copyright {
  font-size: 14px;
  color: $light-1;
}

.footer-bottom-links {
  display: flex;
  gap: 20px;

  a {
    font-size: 14px;
    color: $light-1;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: $dark-1;
    }
  }

  .footer-bottom-link-btn {
    border: none;
    background: transparent;
    padding: 0;
    margin: 0;
    font-size: 14px;
    color: $light-1;
    text-decoration: none;
    transition: color 0.3s ease;
    cursor: pointer;

    &:hover {
      color: $dark-1;
    }
  }
}

.footer-language {
  select {
    background: transparent;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    padding: 8px 15px;
    color: $dark-1;
    font-size: 14px;
    cursor: pointer;
    outline: none;

    option {
      background: #fff;
      color: $dark-1;
    }
  }
}

// ========== GRID ==========
.y-gap-40 {
  margin-top: -20px;
  margin-bottom: -20px;

  > * {
    padding-top: 20px;
    padding-bottom: 20px;
  }
}

.y-gap-10 {
  margin-top: -5px;
  margin-bottom: -5px;

  > * {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}

// ========== RESPONSIVE ==========
@media (max-width: 991px) {
  .footer-bottom {
    .row {
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 15px;
    }
  }

  .footer-bottom-links {
    justify-content: center;
  }
}

@media (max-width: 767px) {
  .pt-60 {
    padding-top: 40px;
  }
  .pb-60 {
    padding-bottom: 40px;
  }

  .footer-social {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
</style>
